import GoodsInspectionPolicy from "./goods-inspection-policy.page";

export default GoodsInspectionPolicy;
